import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ChallengeCarousel = ({ challenges }) => {
  const [currentChallengeIndex, setCurrentChallengeIndex] = useState(
    challenges.length > 0 ? challenges.length - 1 : 0
  );

  const nextChallenge = () => {
    if (currentChallengeIndex < challenges.length - 1) {
      setCurrentChallengeIndex(currentChallengeIndex + 1);
    }
  };

  const prevChallenge = () => {
    if (currentChallengeIndex > 0) {
      setCurrentChallengeIndex(currentChallengeIndex - 1);
    }
  };

  const handleVideoPlay = (challengeTitle, challengeId) => {
    // Send gtag event when video plays
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'video_play', {
        event_category: 'Video',
        event_label: challengeTitle,
        challenge_id: challengeId,
        challenge_day: `Day ${challengeId}`
      });
    }
  };

  if (challenges.length === 0) {
    return (
      <div>
        <p className="mainChallengeDescription" style={{ textAlign: 'center', padding: '2rem 0' }}>
          The first challenge for tomorrow will appear here at 9:30pm tonight.
        </p>
      </div>
    );
  }

  const getChallengeLabel = (challengeDate) => {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    
    // Check if it's 9:30pm or later (21:30)
    const isAfter930pm = currentHour > 21 || (currentHour === 21 && currentMinute >= 30);
    
    // Parse the challenge date to compare
    const challenge = new Date(challengeDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    challenge.setHours(0, 0, 0, 0);
    
    // Calculate if the challenge is for today
    const isTodaysChallenge = challenge.getTime() === today.getTime();
    
    // Calculate if the challenge is for tomorrow
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isTomorrowsChallenge = challenge.getTime() === tomorrow.getTime();
    
    // Return appropriate label
    if (isAfter930pm && isTomorrowsChallenge) {
      return "Tomorrow's Challenge";
    }
    
    if (isTodaysChallenge) {
      return "Today's Challenge";
    }
    
    // Return empty string for old challenges
    return "";
  };

  const currentChallenge = challenges[currentChallengeIndex];

  return (
    <div className="challenge-carousel">
      <div className="carouselHolder">
        <div className="leftBit">
          <button
            onClick={prevChallenge}
            disabled={currentChallengeIndex === 0}
            className=""
          >
            <ChevronLeft className="w-6 h-6" /> 
          </button>
        </div>
        
        <div className="middleBit">
          <h4 className="daysTop">{getChallengeLabel(currentChallenge.dateISO)}</h4>
          <h3 className="">
            <span className='dayColour'>Day {currentChallenge.id}</span> 
            <span className='hiddenSmall'>- </span>
            <br className='hiddenBig'/>
            {currentChallenge.challengeTitle}
          </h3>
          <h4 className="daysBottom">{currentChallenge.date}</h4>
          
          <div className="descriptionArea">
            <div className="descriptionImage">
              {/* Challenge Image */}
              {/* {currentChallenge.challengeImage && (
                <div className="">
                  <img 
                    src={currentChallenge.challengeImage} 
                    alt={currentChallenge.challengeTitle}
                    className="imageFit"
                  />
                </div>
              )} */}
              
              {/* Challenge Video */}
              {currentChallenge.challengeVideo && (
                <div className="mt-4">
                  <video 
                    controls 
                    className="imageFit" 
                    key={currentChallenge.id} 
                    poster={currentChallenge.challengeImage}
                    onPlay={() => handleVideoPlay(currentChallenge.challengeTitle, currentChallenge.id)}
                  >
                    <source src={currentChallenge.challengeVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}
            </div>
            
            <div className="descriptionText">
              <p className="mainChallengeDescription">
                {currentChallenge.challengeDescription}
              </p>
            </div>
          </div>
        </div>
        
        <div className="rightBit">
          <button
            onClick={nextChallenge}
            disabled={currentChallengeIndex === challenges.length - 1}
            className=""
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChallengeCarousel;